/**
 * Spanish (es) mappings for MessageInput
 */

export const messageInputES = {
  // Placeholder text
  "Ask Away!": "¡Pregunta!",

  // UI elements
  "Ideas": "Ideas",
  "PickStar Quick AI Suggestions": "Sugerencias Rápidas IA de PickStar",
  "Upgrade for 2K characters": "Actualiza para 2 mil caracteres",
  "remaining": "restantes",

  // Caution message
  "AI analysis offer insights, not guarantees—use responsibly.": "Los análisis IA ofrecen información, no garantías—usa responsablemente."
};
